import { createI18n } from 'vue-i18n';
import en from './locales/en';
import zhCN from './locales/zh-CN';

export type MessageSchema = typeof en;
export type Locale = 'en' | 'zh-CN';

const i18n = createI18n({
  legacy: false,
  locale: (localStorage.getItem('locale') || 'en') as Locale,
  fallbackLocale: 'en' as Locale,
  messages: {
    'en': en,
    'zh-CN': zhCN,
  },
});

export function setLocale(locale: Locale) {
  (i18n.global.locale as unknown as { value: Locale }).value = locale;
  localStorage.setItem('locale', locale);
  document.documentElement.lang = locale;
}

export function getLocale(): Locale {
  return (i18n.global.locale as unknown as { value: Locale }).value;
}

export default i18n;
